module.exports = __webpack_public_path__ + "img/relevo.b51bcd8f.svg";